export default __webpack_public_path__ + "static/char-s-05-en-b199b1abfa8182bd391affee0e383d6b.png";